import React from 'react';
import styles from './W_CapsulePostContent.module.css';
import A_Indicator from '@/components/A_Atoms/A_Indicator/A_Indicator';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import cn from 'classnames';

interface W_CapsulePostContentProps {
  title: string;
  text: string;
  commentCount: number;
  plantCount: number;
  indicator: 'comment' | 'plant';
}

export default function W_CapsulePostContent({
  title,
  text,
  commentCount,
}: W_CapsulePostContentProps) {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.content}>
        <div className={styles.description}>
          <pre className={cn(styles.text, 'text-p-2')}>{text}</pre>
        </div>
        <div className={styles.indicators_wrapper}>
          <A_Indicator
            count={commentCount}
            icon={
              <Q_Icon.CommentIndicatorIcon width={24} height={24} fill='none' />
            }
          />
        </div>
      </div>
    </div>
  );
}
